import React, { useState } from "react";
import ChildrenGuide from "./childrenGuide/children-guide";
import SocialWorkerInformation from "./socialWorkerInformation/social-worker-information";
import Education from "./education/education";
import Bullying from "./bullying/bullying";
import FormsAndMeetings from "./formsAndMettings/forms-and-mettings";
import Complains from "./complains/complains";
import Health from "./health/health";
import Hobbies from "./hobbies/hobbies";
import HouseRules from "./houseRules/house-rules";
import ContactDetails from "./contactDetails/contact-details";
import Welcome from "./welcome/welcome";
import Family from "./family/family";
import LittleNorway from "./littleNorway/little-norway";
import HouseRulesFirst from "./houseRulesFirst/house-rules-first";
import Privacy from "./privacy/privacy";
import Food from "./food/food";
import Cloths from "./cloths/cloths";
import EducationLast from "./educationLast/education-last";

const CypForm = () => {
  const [currentStep, setCurrentStep] = useState(0); // Step index
  const [formData, setFormData] = useState({
    childrenGuideInfo: {},
    familyInfo: {},
    socialWorkerInfo: {},
    littleNorwayInfo: {},
  });

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // Update data for each form
  const updateFormData = (newData) => {
    setFormData((prevState) => ({
      ...prevState,
      ...newData,
    }));
  };

  console.log("formData", formData);

  const handleSubmit = () => {
    console.log("Final Form Data:", formData);
  };

  // Rendering forms based on step
  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return <Welcome nextStep={nextStep} />;
      case 1:
        return <ChildrenGuide updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 2:
        return <Family updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 3:
        return <SocialWorkerInformation updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 4:
        return <LittleNorway updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 5:
        return <HouseRulesFirst nextStep={nextStep} prevStep={prevStep} />;
      case 6:
        return <HouseRules nextStep={nextStep} prevStep={prevStep} />;
      case 7:
        return <Privacy nextStep={nextStep} prevStep={prevStep} />;
      case 8:
        return <Food nextStep={nextStep} prevStep={prevStep} />;
      case 9:
        return <Hobbies nextStep={nextStep} prevStep={prevStep} />;
      case 10:
        return <Health nextStep={nextStep} prevStep={prevStep} />;
      case 11:
        return <Cloths nextStep={nextStep} prevStep={prevStep} />;
      case 12:
        return <Education nextStep={nextStep} prevStep={prevStep} />;
      case 13:
        return <EducationLast nextStep={nextStep} prevStep={prevStep} />;
      case 14:
        return <Bullying nextStep={nextStep} prevStep={prevStep} />;
      case 15:
        return <FormsAndMeetings nextStep={nextStep} prevStep={prevStep} />;
      case 16:
        return <Complains nextStep={nextStep} prevStep={prevStep} />;
      case 17:
        return <ContactDetails prevStep={prevStep} handleSubmit={handleSubmit} />;
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};

export default CypForm;
